import { PromotionContextProvider } from "src/contexts/promotion.context";
import { PromoWrapper } from "./ProductList.styled";
import { BrandsPromo } from "src/molecules/BrandsPromo";
import { useState } from "react";

function Promotion({ slug }: { slug: string }): JSX.Element | null {
  const [displayPromo, setDisplayPromo] = useState(true);

  if (!displayPromo) {
    return null;
  }

  return (
    <PromoWrapper>
      <PromotionContextProvider>
        <BrandsPromo slug={slug} callback={setDisplayPromo} />
      </PromotionContextProvider>
    </PromoWrapper>
  );
}

export { Promotion };
